import type { Language, Page } from "../types";
import { useI18n } from "../i18n";

const titleKeys: Record<
  Page,
  | "header.dashboard"
  | "header.meetings"
  | "header.calendar"
  | "header.translate"
  | "header.skills"
  | "header.search"
  | "header.settings"
  | "header.privacy"
> = {
  dashboard: "header.dashboard",
  meetings: "header.meetings",
  calendar: "header.calendar",
  translate: "header.translate",
  skills: "header.skills",
  search: "header.search",
  settings: "header.settings",
  privacy: "header.privacy",
};
const subtitleKeys: Record<
  Page,
  | "subtitle.dashboard"
  | "subtitle.meetings"
  | "subtitle.calendar"
  | "subtitle.translate"
  | "subtitle.skills"
  | "subtitle.search"
  | "subtitle.settings"
  | "subtitle.privacy"
> = {
  dashboard: "subtitle.dashboard",
  meetings: "subtitle.meetings",
  calendar: "subtitle.calendar",
  translate: "subtitle.translate",
  skills: "subtitle.skills",
  search: "subtitle.search",
  settings: "subtitle.settings",
  privacy: "subtitle.privacy",
};

export function Header({
  page,
  onNewMeeting,
}: {
  page: Page;
  onNewMeeting: () => void;
}): React.JSX.Element {
  const { language, setLanguage, t } = useI18n();
  return (
    <header className="topbar">
      <div>
        <p className="eyebrow">{t("header.private")}</p>
        <h1>{t(titleKeys[page])}</h1>
        <p>{t(subtitleKeys[page])}</p>
      </div>
      <div className="topbar-actions">
        <label className="language-control">
          <span>{t("language.label")}</span>
          <select
            aria-label={t("language.label")}
            value={language}
            onChange={(event) => setLanguage(event.target.value as Language)}
          >
            <option value="en">{t("language.english")}</option>
            <option value="zh-CN">{t("language.chinese")}</option>
          </select>
        </label>
        {page !== "meetings" && (
          <button className="primary" type="button" onClick={onNewMeeting}>
            + {t("dashboard.newMeeting")}
          </button>
        )}
      </div>
    </header>
  );
}
